import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

type activationOrderTechnicalInfoCalculateStatusType = {
  id: string;
  errorCallback: Function;
  resultKey?: string;
  successCallback?: Function;
};

export default ({
  id,
  errorCallback,
  successCallback,
  resultKey = 'activationOrderCalculateStatusData',
}: activationOrderTechnicalInfoCalculateStatusType) =>
  requestAsync({
    url: endpoints.getActivationOrderCalculateStatusUrl(id),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getActivationOrderCalculateStatusUrl(id),
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      errorCallback,
      successCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
